import { render, staticRenderFns } from "./DemandInsightsText.vue?vue&type=template&id=f694706a"
import script from "./DemandInsightsText.vue?vue&type=script&lang=js"
export * from "./DemandInsightsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports